import React, { useEffect, useState } from 'react';

const CustomSubtitle = (props) => {

    return (
        <p style={{
            fontSize: 16,
            fontWeight: '400',
            color: '#707070',
            padding: 0, margin: 0,
        }}
        data-tippy-content={`${props.setToolTip[0] ? props.setToolTip[1] : ''}`}
        >{props.children}</p>
    );
};

export default CustomSubtitle;
